import React from "react";
import { Checkbox } from "office-ui-fabric-react/lib/Checkbox";

const CheckBox = props => {
  const { value, label, touched, error, style } = props;

  return (
    <div style={style}>
      <Checkbox 
        label={label} 
        checked={value} 
        onChange={(ev, isChecked) => props.onChange("archived", isChecked)} />
      {!!error && touched && <div className="error-message">{error}</div>}
    </div>
  );
};

export default CheckBox;



// WEBPACK FOOTER //
// ./src/common/Dropdowns/_CheckBox.js